import {AxiosRequestConfig, AxiosResponse} from 'axios'
import {ExceptionError} from '../exception'
import {Request} from '../request'
import {ICompany, ICompanyCreate, ICompanyUpdate} from '../../interface/company/company'
import {IPageOption} from '../../interface/paging/paging'
import {IApiResponse} from '../../interface/api-response/api-response'
import {API_PATH} from '../../constants/api-path'
import {IMenu} from '../../interface/menu/menu'

export class GetMenuService extends Request {
  async request(options?: IPageOption) {
    try {
      const {data} = await this.client
        .get<IApiResponse<IMenu[]>>(API_PATH.MENU, {
          params: options,
        })
        .then((d) => d.data)

      return data
    } catch (error: any) {
      throw new ExceptionError(error.response.data)
    }
  }
}
export class GetMyMenuService extends Request {
  async request(options?: any) {
    try {
      const {data} = await this.client
        .get<IApiResponse<IMenu[]>>(`${API_PATH.MENU}/me`, {
          params: options,
        })
        .then((d) => d.data)

      return data
    } catch (error: any) {
      throw new ExceptionError(error.response.data)
    }
  }
}
export class CreateMenuService extends Request {
  async request(payload: any) {
    const {data} = await this.client.post<ICompany>(API_PATH.MENU, payload)
    try {
      return data
    } catch (error: any) {
      throw new ExceptionError(error.response.data)
    }
  }
}
export class UpdateMenuService extends Request {
  async request(payload: any) {
    try {
      const {data} = await this.client.patch<ICompany>(API_PATH.MENU, payload)
      return data
    } catch (error: any) {
      throw new ExceptionError(error.response.data)
    }
  }
}
